import * as Colors from 'material-ui/styles/colors';

export const avatar = {
    default: {
        backgroundColor:    'rgb(35, 151, 190)'
    },
    defaultDark: {
        backgroundColor:    'rgb(31, 115, 146)'
    },
    waiting: {
        backgroundColor:    Colors.red900
    },
    waitingRequired: {
        backgroundColor:    Colors.red900
    },
    required: {
        backgroundColor:    Colors.red900
    },
    enrolled: {
        backgroundColor:    Colors.amber300
    },
    enrolledRequired: {
        backgroundColor:    Colors.amber800
    },
    inProgress: {
        backgroundColor:    Colors.amberA200
    },
    inProgressRequired: {
        backgroundColor:    Colors.amber600
    },
    completed: {
        backgroundColor:    Colors.green500
    },
    cancelled: {
        backgroundColor:    Colors.grey400
    },
    disabled: {
        backgroundColor:    Colors.grey300
    },

    expiring: {
        backgroundColor:Colors.amberA200
    },
    expired: {
        backgroundColor:Colors.red900
    },
    permanent: {
        backgroundColor:Colors.cyan800
    },

    defaultEvent: {
        color: 'rgb(117, 117, 117)',
        backgroundColor: Colors.grey300
    },
    did_not_attendEvent: {
        backgroundColor: Colors.grey300
    },
    waitingEvent: {
        backgroundColor: '#AEE9FC'
    },
    attendingEvent: {
        backgroundColor: 'rgb(35, 151, 190)'
    },
    attendedEvent: {
        backgroundColor: Colors.green500
    },


    moduleDefault: {
        backgroundColor:    'rgb(35, 151, 190)'
    },
    moduleEnrolled: {
        backgroundColor:   '#00C3ED'
    },
    moduleCompleted: {
        backgroundColor:    Colors.green500
    },
    modulePassed: {
        backgroundColor:    Colors.green500
    },
    moduleCanceled: {
        backgroundColor:    Colors.grey300
    },

    courseDefault: {
        backgroundColor:    'rgb(35, 151, 190)'
    },
    courseCompleted: {
        backgroundColor:    Colors.green500
    },
    coursePassed: {
        backgroundColor:    Colors.green500
    },
    courseCanceled: {
        backgroundColor:    Colors.grey300
    }
};


export const statusIcon = {
    default: {
        color:  'rgb(35, 151, 190)'
    },
    waiting: {
        color:  Colors.amberA200
    },
    attending: {
        color: Colors.amberA700
    },
    attended: {
        color: Colors.green500
    },
    didNotAttend: {
        color: Colors.red900
    },

    error: {
        color: Colors.red900
    }
};

export const statusColours = {
    'default':   'rgba(117, 117, 117, 1)',
    'medium':   'rgba(117, 117, 117, 0.6)',
    'light':     'rgba(224, 224, 224, 1)',
    'disabled':  'rgba(224, 224, 224, 0.5)',
    'cancelled': 'rgba(117, 117, 117, 0.4)',
    'waiting':   'rgba(117, 117, 117, 0.6)',
    'enrolled':  'rgba(35, 151, 190, 0.6)',
    'partial':   'rgb(174, 233, 252)',
    'completed': 'rgba(35, 151, 190, 1)',
    'deleted':   'rgba(117, 117, 117, 0.6)',
    'warning': Colors.amberA200,
    'passed': Colors.green500,
    'failed': Colors.red900,
    'expired': Colors.red900,
    'expiring': Colors.amberA200,
    'error': Colors.red900,
    'mandatory': '#B71B1C',
    'optional': '#F9B205',
    'primary': 'rgba(35, 151, 190, 1)',
    'primary_2': 'rgba(32, 119, 147, 1)',
    'primary_3': 'rgba(56, 171, 218, 1)',
    'primary_4': 'rgba(194, 235, 252, 1)',
    'primary_o': 'rgba(35, 151, 190, .8)',
    'primary_2_o': 'rgba(32, 119, 147, .8)',
    'primary_3_o': 'rgba(56, 171, 218, .8)',
    'primary_4_o': 'rgba(194, 235, 252, .8)',
    'secondary':   '#ff9800',
    'secondary_o': 'rgba(260, 201, 72, .6)',
};



export default {
    avatar
};
